import { render, staticRenderFns } from "./page-order-money.vue?vue&type=template&id=4268e898&scoped=true"
import script from "./page-order-money.vue?vue&type=script&lang=js"
export * from "./page-order-money.vue?vue&type=script&lang=js"
import style0 from "./page-order-money.vue?vue&type=style&index=0&id=4268e898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268e898",
  null
  
)

export default component.exports